export const assignFeesData = [
    {
      key: "1",
      sNo: "01",
      feesGroup: "Admission-Fees",
      feesType: "Tuition Fees",
      class: "I",
      section: "B",
      amount: "1250",
      gender: "Male",
      category: "BC",
    },
    {
      key: "2",
      sNo: "02",
      feesGroup: "Class 1 General",
      feesType: "Monthly Fees",
      class: "III",
      section: "C",
      amount: "250",
      gender: "Both",
      category: "MBC",
    },
    {
      key: "3",
      sNo: "03",
      feesGroup: "Monthly Fees",
      feesType: "Admission Fees",
      class: "IX",
      section: "F",
      amount: "656",
      gender: "Female",
      category: "FC",
    },
    {
      key: "4",
      sNo: "04",
      feesGroup: "Class 1 Lump Sum",
      feesType: "Bus Fees",
      class: "X",
      section: "R",
      amount: "6225",
      gender: "Male",
      category: "BC",
    },
    {
      key: "5",
      sNo: "05",
      feesGroup: "Class 1- I Installment",
      feesType: "Monthly Fees",
      class: "III",
      section: "E",
      amount: "454",
      gender: "Both",
      category: "MBC",
    },
    {
      key: "6",
      sNo: "06",
      feesGroup: "Class 1-II Installment",
      feesType: "Monthly Fees",
      class: "IV",
      section: "A",
      amount: "214",
      gender: "Male",
      category: "All",
    },
    {
      key: "7",
      sNo: "07",
      feesGroup: "Discount",
      feesType: "Topper Discount",
      class: "V",
      section: "B",
      amount: "145",
      gender: "Both",
      category: "FC",
    },
    {
      key: "8",
      sNo: "08",
      feesGroup: "Class 3- I Installment",
      feesType: "3rd-Installment-Fees",
      class: "X",
      section: "B",
      amount: "147",
      gender: "Male",
      category: "FC",
    },
    {
      key: "9",
      sNo: "09",
      feesGroup: "Class 2- I Installment",
      feesType: "3rd-Installment-Fees",
      class: "VI",
      section: "A",
      amount: "457",
      gender: "Female",
      category: "FC",
    },
    {
      key: "10",
      sNo: "10",
      feesGroup: "Class 4- I Installment",
      feesType: "3rd Installment Fees",
      class: "V",
      section: "A",
      amount: "654",
      gender: "Female",
      category: "All",
    },
  ];